<template>
  <div id="login">
    <index-header></index-header>
    <div class="container">
      <div class="imgcontainer">
        <img src="static/images/loginimg.png" />
      </div>
      <div class="formcontainer">
        <div class="title">
          <a @click="change1" id="acolor">{{ $t("innerlogin") }}</a>
        </div>
        <div class="inline-title"></div>
        <div class="title1">
          <a @click="change2" id="bcolor">{{ $t("outterlogin") }}</a>
        </div>

        <Form id="form_login" ref="submitForm" v-show="show">
          <div class="input-name">
            <input
              type="text"
              v-model="submitForm.username"
              :placeholder="$t('domain_account')"
              id="username"
              name="username"
            />
          </div>
          <div class="input-password">
            <input
              type="password"
              v-model="submitForm.password"
              :placeholder="$t('password')"
              id="password"
              name="password"
            />
          </div>
        </Form>

        <Form id="form_login_outter" ref="submitForm" v-show="showother">
          <div class="input-name">
            <input
              type="text"
              v-model="submitForm.username"
              :placeholder="$t('loginname')"
              @keyup.enter="login"
            />
          </div>

          <div class="input-password">
            <input
              type="password"
              v-model="submitForm.password"
              :placeholder="$t('password')"
              @keyup.enter="login"
            />
          </div>
        </Form>
        <div class="input-code">
          <input
            type="text"
            :placeholder="$t('code')"
            @keyup.enter="login"
            v-model="inputcode"
          />
        </div>
        <div class="display-code">
          <input
            type="text"
            class="code"
            disabled="disabled"
            v-model="showcode"
          />
        </div>

        <div class="btn-submit">
          <button type="submit" @click="login()">{{ $t("loginnow") }}</button>
        </div>
        <!-- <div class="a-forget" v-show="showother">
                    <a style="cursor:pointer;font-size: 14px;" type="primary"  
                        @click="forget">{{$t('forgetPassword')}}
                    </a>
                </div> -->
      </div>
    </div>

    <Modal
      v-model="modelUpdate"
      :closable="false"
      :mask-closable="false"
      :title="$t('updatePassword')"
    >
      <div slot="footer">
        <Button type="primary" size="small" @click="cancel">{{
          $t("cancle")
        }}</Button>
        <Button
          type="primary"
          size="small"
          @click="submitUserForm('updatePasswordForm')"
          >{{ $t("confrim") }}</Button
        >
      </div>
      <el-form
        :model="updatePasswordForm"
        ref="updatePasswordForm"
        :rules="rules"
        label-width="130px"
      >
        <span style="color: red; margin-left: 40px; font-size: 15px;">{{
          $t("firstLogin")
        }}</span>
        <el-form-item
          style="margin-top: 10px;"
          :label="$t('newpwd')"
          prop="password1"
        >
          <el-input
            clearable
            v-model="updatePasswordForm.password1"
            type="password"
            :placeholder="$t('password')"
          />
        </el-form-item>
        <el-form-item :label="$t('verifypwd')" prop="password2">
          <el-input
            clearable
            v-model="updatePasswordForm.password2"
            type="password"
            :placeholder="$t('password')"
          />
        </el-form-item>
      </el-form>
    </Modal>
    <Modal
      v-model="modelForget"
      :closable="false"
      :mask-closable="false"
      :title="$t('resetPassword')"
    >
      <div slot="footer">
        <Button type="primary" size="small" @click="cancle">{{
          $t("cancle")
        }}</Button>
        <Button
          type="primary"
          size="small"
          @click="submitPasswordForm('forgetPasswordForm')"
          >{{ $t("confrim") }}</Button
        >
      </div>
      <el-form
        :model="forgetPasswordForm"
        ref="forgetPasswordForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item
          style="margin-top: 10px;"
          :label="$t('userAccount')"
          prop="userAccount"
        >
          <el-input
            clearable
            v-model="forgetPasswordForm.userAccount"
            type="text"
            :placeholder="$t('loginname')"
          />
        </el-form-item>
        <el-form-item :label="$t('userEmail')" prop="empEmail">
          <el-input
            clearable
            v-model="forgetPasswordForm.empEmail"
            type="text"
            :placeholder="$t('enterEmail')"
          />
        </el-form-item>
      </el-form>
    </Modal>
  </div>
</template>
<script type="text/javascript">
import aes from "@/utils/aes";
import indexHeader from "@/components/public/indexheader";
import h3cFooter from "@/components/public/footer";
import * as validate from "@/utils/validate";

var tableIndex = "1";
export default {
  components: { indexHeader, h3cFooter },

  data() {
    var checkPassword1 = (rule, value, callback) => {
      setTimeout(() => {
        if (value == "123") {
          var msg = this.$t("loginErrorMsg9");
          return callback(new Error(msg));
        } else {
          callback();
        }
      }, 100);
    };
    var checkPassword2 = (rule, value, callback) => {
      let password = this.updatePasswordForm.password1;
      setTimeout(() => {
        if (password != value) {
          var msg = this.$t("loginErrorMsg8");
          return callback(new Error(msg));
        } else {
          callback();
        }
      }, 100);
    };
    var checkUserName = (rule, value, callback) => {
      let params = {
        userAccount: value
      };
      let url = `${this.$store.state.islhurl}checkUserAccount`;
      this._post(url, params).then(res => {
        if (res == "1") {
          var msg = this.$t("loginErrorMsg7");
          return callback(new Error(msg));
        } else {
          this.userId = res.userId;
          callback();
        }
      });
    };
    var checkEmail = (rule, value, callback) => {
      let params = {
        userAccount: this.forgetPasswordForm.userAccount,
        empEmail: value
      };
      let url = `${this.$store.state.islhurl}checkNameAndEmail`;
      this._post(url, params).then(res => {
        if (res == "0") {
          var msg = this.$t("loginErrorMsg6");
          return callback(new Error(msg));
        } else {
          callback();
        }
      });
    };
    return {
      show: true,
      userId: "",
      modelUpdate: false,
      modelForget: false,
      submitForm: {
        userAccount: "",
        password: "",
        inner: null
      },
      showother: false,
      username: null,
      password: null,
      username_out: null,
      password_out: null,
      code1: null,
      checkcode: "",
      inputcode: "",
      showcode: "",
      updatePasswordForm: {
        password1: "",
        password2: ""
      },
      forgetPasswordForm: {
        userAccount: "",
        empEmail: ""
      },
      rules: {
        password1: [
          {
            required: true,
            message: "Please fill in the password",
            trigger: "blur"
          },
          { validator: checkPassword1, trigger: "blur" }
        ],
        password2: [
          {
            required: true,
            message: "Please fill in the password",
            trigger: "blur"
          },
          { validator: checkPassword2, trigger: "blur" }
        ],
        userAccount: [
          {
            required: true,
            message: "Please fill in the account",
            trigger: "blur"
          },
          { validator: checkUserName, trigger: "blur" }
        ],
        empEmail: [
          {
            required: true,
            message: "Please fill in the email",
            trigger: "blur"
          },
          { validator: checkEmail, trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.createCode(); //初始化生成一个4位数的验证码
    this.$store.commit("clearAllTags");
    sessionStorage.removeItem("islhtoken");
    sessionStorage.removeItem("eostoken");
    sessionStorage.removeItem("userRolePerm");
    localStorage.removeItem('TY_USER_ID');
    localStorage.removeItem('DOMAIN_ACCOUNT');
  },
  mounted() {
    this.change1();
  },
  methods: {
    cancel() {
      this.modelUpdate = false;
    },
    cancle() {
      this.modelForget = false;
    },
    submitPasswordForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.resetPassword();
        } else {
          return false;
        }
      });
    },
    resetPassword() {
      let params = {
        id: this.userId,
        userAccount: this.forgetPasswordForm.userAccount,
        empEmail: this.forgetPasswordForm.empEmail
      };
      let url = `${this.$store.state.islhurl}resetPassword`;
      this._post(url, params).then(res => {
        if (res == "200") {
          this.modelForget = false;
          var msg = this.$t("loginErrorMsg4");
          this.$Message.success(msg);
        } else if (res == "500") {
          var msg = this.$t("loginErrorMsg5");
          this.$Message.success(msg);
        } else {
          var msg = this.$t("SystemError");
          this.$Message.success(msg);
        }
      });
    },
    submitUserForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.confrimUpdate();
        } else {
          return false;
        }
      });
    },
    confrimUpdate() {
      let url = `${this.$store.state.islhurl}updatePassword`;
      let parms = {
        userAccount: this.submitForm.username,
        password: this.updatePasswordForm.password1,
        islhToken: sessionStorage.getItem("islhtoken")
      };
      this._post(url, parms).then(res => {
        if (res == "0") {
          this.getPermssionByLongIn();
          this.$router.push({
            path: "/indexw"
          });
        } else {
          var msg = this.$t("loginErrorMsg3");
          this.$Message.error(msg);
        }
      });
    },
    createCode() {
      var code = "";
      var codeLength = 4; //验证码的长度
      var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9); //随机数
      for (var i = 0; i < codeLength; i++) {
        //循环操作
        var index = Math.floor(Math.random() * 10); //取得随机数的索引（0~35）
        code += random[index]; //根据索引取得随机数加到code上
      }
      this.showcode = code; //把code值赋给验证码
    },
    validateCheckCode() {
      var num = this.inputcode; //输入内容全部转化为大写
      if (num.length <= 0) {
        var msg = this.$t("inputErrorCode2");
        this.$Message.error(msg);
        return false;
      } else if (num != this.showcode) {
        var msg = this.$t("inputErrorCode");
        this.$Message.error(msg);
        this.createCode();
        return false;
      } else {
        return true;
      }
    },
    change1: function() {
      var inlogin = document.getElementById("acolor");
      var outlogin = document.getElementById("bcolor");
      inlogin.style.setProperty("color", "#027AFF");
      outlogin.style.setProperty("color", "#333333");

      this.show = true;
      this.showother = false;
      this.username_out = null;
      this.password_out = null;
      this.code1 = null;
      this.createCode();
      tableIndex = "1";
    },
    change2: function() {
      var inlogin = document.getElementById("acolor");
      var outlogin = document.getElementById("bcolor");
      outlogin.style.setProperty("color", "#027AFF");
      inlogin.style.setProperty("color", "#333333");
      this.show = false;
      this.showother = true;
      this.username = null;
      this.password = null;
      this.code1 = null;
      this.createCode();
      tableIndex = "0";
    },
    login: function() {
      var checkflag = this.validateCheckCode();
      if (checkflag == true) {
        if (!this.submitForm.username || !this.submitForm.password) {
          var msg = this.$t("loginErrorMsg1");
          this.$Message.error(msg);
          return;
        }
        // 对密码进行加密
        let encryptionPassword = aes.encrypt(this.submitForm.password);
        let url = `${this.$store.state.islhurl}loginApi`;
        let parms = {
          username: this.submitForm.username,
          password: encryptionPassword,
          inner: tableIndex
        };
        this._post(url, parms).then(res => {
          if (res.code === 200) {
            sessionStorage.setItem("eostoken", res.data.eostoken);
            sessionStorage.setItem("islhtoken", res.data.islhtoken);
            this.getPermssionByLongIn();
            let redirectUrl = sessionStorage.getItem("redirectUrl");
            if (redirectUrl) {
              this.$router.push("/" + redirectUrl);
              this.$store.commit("tagChange", redirectUrl);
            } else {
              this.$router.push({ path: "/indexw" });
            }
          } else if (res.code == "20207") {
            var msg = this.$t("loginErrorMsg");
            this.$Message.error(msg);
          } else if (res.code == "20223") {
            var msg = this.$t("loginErrorMsg2");
            this.$Message.error(msg);
          } else if (res.code == "Role") {
            var msg = this.$t("loginErrorMsg11");
            this.$message({
              type: "error",
              showClose: true,
              duration: 5000,
              message: msg
            });
          } else if (res.code == "Freeze") {
            var msg = this.$t("loginErrorMsg10");
            this.$message({
              type: "error",
              showClose: true,
              duration: 5000,
              message: msg
            });
          } else {
            var msg = this.$t("SystemError");
            this.$Message.error(msg);
          }
        });
      }
    },
    getPermssionByLongIn() {
      let url = `${this.$store.state.islhurl}getPermssionByLongIn`;
      let parms = {
        islhToken: sessionStorage.getItem("islhtoken")
      };
      this._post(url, parms).then(res => {
        sessionStorage.setItem("userRolePerm", JSON.stringify(res));
      });
    },
    forget: function() {
      this.modelForget = true;
    }
    // getToken(){
    //     let url = `http://api.eos-ts.h3c.com/user/v1.0/account/token`
    //     let pm = {
    //         account : 'ygw1353',
    //         password : 'xxxxxx',
    //     }
    //     // console.log(pm);
    //     this._post(url,pm).then(
    //         res =>{
    //             if(res.code=='20220'){
    //                 let token = res.data.token;
    //                 sessionStorage.setItem('token', token);
    //             }
    //         }
    //     )
    // },
  }
};
window.alert = function(name) {
  var iframe = document.createElement("IFRAME");
  iframe.style.display = "none";
  iframe.setAttribute("src", "data:text/plain,");
  document.documentElement.appendChild(iframe);
  window.frames[0].window.alert(name);
  iframe.parentNode.removeChild(iframe);
};
</script>

<style lang="less" scoped>
#login {
  width: 100%;
  height: 100%;

  .container {
    width: 1001px;
    height: 559px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 23px 0px rgba(223, 235, 250, 1);
    position: relative;
    top: 5px;
    left: calc((100% - 1001px) * 7 / 16);
  }
  .imgcontainer {
    width: 525px;
    height: 558px;
    margin: 0 0 1px 41px;
    position: absolute;
  }
  .formcontainer {
    width: 435px;
    height: 559px;
    margin-left: 566px;
    position: relative;
  }
  .form-detail {
    width: 186px;
    height: 36px;
  }

  .title {
    width: 80px;
    height: 28px;
    font-size: 20px;

    font-weight: 600;
    line-height: 28px;
    position: absolute;
    top: 129px;
    left: 90px;
  }
  a {
    color: #333333;
  }

  .title1 {
    width: 80px;
    height: 28px;
    font-size: 20px;

    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 28px;
    position: absolute;
    top: 129px;
    left: 240px;
  }
  .inline-title {
    width: 1px;
    height: 15px;
    background: rgba(203, 211, 222, 1);
    position: absolute;
    top: 136px;
    left: 208px;
  }
  .input-name {
    width: 302px;
    height: 42px;
    top: 182px;
    right: 76px;
    position: absolute;
    border: 1px solid rgba(203, 211, 222, 1);
  }
  input {
    display: block;
    width: 285px;
    height: 40px;
    font-size: 14px;
    line-height: inherit;
    // border:1px solid rgba(203,211,222,1);
    outline: medium;
    border: none;
    margin-left: 15px;
  }
  .input-password {
    width: 302px;
    height: 42px;
    top: 249px;
    right: 76px;
    position: absolute;
    border: 1px solid rgba(203, 211, 222, 1);
  }
  .input-code {
    width: 141px;
    height: 42px;
    top: 316px;
    left: 57px;
    position: absolute;
    border: 1px solid rgba(203, 211, 222, 1);
  }
  .input-code input {
    display: block;
    width: 124px;
    height: 40px;
    font-size: 14px;
    line-height: inherit;
  }
  .display-code {
    width: 141px;
    height: 42px;
    top: 316px;
    left: 218px;
    position: absolute;
    border: 1px solid rgba(203, 211, 222, 1);
  }
  .display-code input {
    display: block;
    width: 141px;
    height: 42px;
    font-size: 20px;
    line-height: inherit;
    color: #ffffff;
    background-color: #017aff;
    font-family: Arial;
    font-style: italic;
    border: 0;
    padding: 2px 3px;
    letter-spacing: 3px;
    font-weight: bolder;
    text-align: center;
    margin-left: 0px;
  }
  .a-forget {
    width: 302px;
    height: 42px;
    top: 440px;
    right: 65px;
    position: absolute;
  }
  .btn-submit {
    width: 302px;
    height: 42px;
    top: 388px;
    right: 76px;
    position: absolute;
  }
  .btn-submit button {
    width: 302px;
    height: 42px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 20px;
    background-color: #017aff;
    text-align: center;
    border: none;
  }
  input:-webkit-autofill {
    border: 1px solid #ffffff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/login/login.vue